(() => {
  const ROOT_SELECTOR = '[data-hr-spirit-owned]';
  const TAIL_SELECTOR = '[data-hr-spirit-tail]';
  const DEFERRED_VIDEO_SELECTOR = '[data-hr-spirit-deferred-video]';
  const DEFERRED_BACKGROUND_SELECTOR = '[data-hr-spirit-good-high][data-hr-spirit-good-high-desktop-background]';
  const REVIEW_COUNT_SOURCE_SELECTOR = '.jdgm-preview-badge .jdgm-prev-badge[data-number-of-reviews], #judgeme_product_reviews .jdgm-rev-widg[data-number-of-reviews]';
  const REVIEW_COUNT_TARGET_SELECTOR = '[data-hr-spirit-rating-text]';
  let deferredVideoObserver = null;
  let deferredBackgroundObserver = null;
  let reviewCountSource = null;
  let reviewCountObserver = null;
  let reviewCountDiscoveryObserver = null;
  const SELECTED_OPTION_CLASSES = {
    'd3f54907-9562-472c-a62e-a116cd460dc2': 'r-h1gbq8',
    '2125fce2-dad1-490d-8298-ae895c433bc2': 'r-pxi0dj',
    '67f6a3b2-e17c-4b38-acd1-9b82036521be': 'r-1pglzq2'
  };
  const THREE_PLUS_OPTION_INDEX = 2;
  const THREE_PLUS_MINIMUM = 3;
  const DEFAULT_THREE_PLUS_MAXIMUM = 6;
  const ADDITIONAL_BOTTLE_PRICE_CENTS = 8999;
  // Exact discounted cart totals; storefront labels intentionally omit cents.
  const CHECKOUT_BUNDLE_TOTALS_CENTS = {
    1: 9999,
    2: 18999,
    3: 26999
  };
  const CART_PRICE_VERIFICATION_ERROR = 'The offer price could not be verified.';
  const CART_CONFIRMATION_DELAYS_MS = [250, 500];
  const THC_PER_BOTTLE_MG = 1270;
  const THUMBNAIL_ACTIVE_FRAME_CLASS = 'r-1sqc0ux';
  const THREE_PLUS_QUANTITY_RID = '0badc1cc-731e-493b-bf6b-cc8660469cfd';
  const SPIRIT_FLAVORS = [
    { key: 'B', name: 'Berry Whip' },
    { key: 'S', name: 'Strawberry Shortcake' },
    { key: 'P', name: 'Peach Cobbler' }
  ];
  const SKU_FLAVOR_KEYS = { BER: 'B', STR: 'S', PEA: 'P' };
  const DEFAULT_SPIRIT_MIXES = {
    1: { B: 0, S: 0, P: 1 },
    2: { B: 1, S: 0, P: 1 },
    3: { B: 1, S: 1, P: 1 }
  };
  const EXPECTED_SPIRIT_MIXES = {
    1: ['B', 'S', 'P'],
    2: ['BB', 'BS', 'BP', 'SS', 'SP', 'PP'],
    3: ['BBB', 'BBS', 'BBP', 'BSS', 'BSP', 'BPP', 'SSS', 'SSP', 'SPP', 'PPP']
  };
  const BENEFIT_RIDS = {
    '1': '698a0a6e-b1d7-4640-b605-7da9741c8eb1',
    '2': 'a0307c3c-2697-4580-92e6-55385521440d',
    '3': 'c0118920-ca84-41cc-a3dd-3c102c0edc71',
    '4': 'a8b0f58a-d1e7-48e5-99d1-45a0fd6e7c83'
  };
  const OFFER_RIDS = {
    '1': {
      quantity: '1c8ddc86-f468-449e-8e60-9e25c5c7aae8',
      meta: '5422681b-230f-46b1-a15c-c9b04751fed3',
      price: 'eb4a3fa3-4228-460b-b8a7-337aacc717b4',
      comparePrice: '222d6d59-7d80-4038-9aaa-87db705f400c',
      savings: '6d9be7ac-9cab-4699-86d9-31093bdb38d0',
      guarantee: 'aec6515b-1725-4de8-bb3f-c8a162698e87'
    },
    '2': {
      quantity: 'c64820ae-90a8-48d7-9f96-e5945b4001bf',
      badge: '82427196-dd8a-407a-905e-129906cb8d60',
      meta: 'ade1fff9-f836-4285-afcb-d7996f1f7bbe',
      price: '2cc06e8f-7e76-4a46-ab28-b5dba97a2bbe',
      comparePrice: 'a4d1679a-3091-4d55-9190-7f9c269e5609',
      savings: '2f4d0037-b4c2-4a04-a05b-811a31ed7778',
      bonus: 'aaf84573-ee0f-453c-a2c3-5b6e12783d31',
      guarantee: 'f2c259b2-868f-4ea0-a752-afaa9e143e04'
    },
    '3': {
      badge: 'b5d8b03f-818f-4dac-b2ab-df57cee45af1',
      meta: '447d62c8-73b4-4d5e-9632-0267ed899cc0',
      price: 'ac71b1ac-dccb-46ef-89a8-d0f6d0cc2ce3',
      comparePrice: '9c91a2bc-08ae-49d2-9904-503d97b068bb',
      savings: '760117a5-cc30-4662-8f2d-67df6507588b',
      bonus: 'b1106ea4-3ce3-4375-b19f-99feb2139534',
      guarantee: '3d040045-c724-4565-8142-4e4cf637f871'
    }
  };
  const DETAIL_RIDS = {
    guarantee: {
      heading: '183032ac-fb90-453b-a197-129dd3dd0915',
      body: 'f48294cf-c43b-4c6d-b6c8-f1efc74fbeb9'
    },
    taste: {
      heading: '43c1ca43-8e53-4eec-80e2-1d449dbd7c2e',
      body: 'fb14d362-b724-4487-87fb-64cf51abb179'
    },
    nutrition: {
      heading: 'e813c982-b9f9-4845-8332-4cc3bf3947c0',
      body: '703b3bbd-89fd-4ff3-888a-adf0e45fc8cb',
      bodySecondary: '0335ba85-ebfd-4757-b35e-83b66c462b18',
      bodyTertiary: '305c2493-0a8b-4a71-a2dc-3ad2e291084d'
    }
  };
  const MEDIA_RIDS = {
    benefit1: 'f41a78ad-c11e-4c16-924f-e162535c12ed',
    benefit2: 'a1423efe-debc-4cf9-ab3b-dc88d615df6e',
    benefit3: 'fc9e951e-b4ee-466c-a60e-77c96acc9508',
    benefit4: 'aa3d3c87-d5bc-44cc-b81c-6eb82788cc91',
    offer1: '1842c6f0-7e81-409a-ad3c-48fc77e9c111',
    offer2: '79850f78-873a-4abb-98b2-39d5747d6f5f',
    offer3: '4731f683-fd45-46f5-92d8-194a49be0d5f',
    trustLab: 'dcc5b670-21f5-42ac-b55c-28421b0e0523',
    trustNatural: '32a09032-df19-4737-b9d0-d295ca5268f3',
    trustUsa: '17fd6dd5-df00-4803-97d5-cec5cb7d2440',
    trustLegal: '58b6aa81-e1b2-4853-8e44-7bbf35a8dd66'
  };

  const parseConfig = (root) => {
    const node = root.querySelector('[data-hr-spirit-config]');
    if (!node) return null;

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.error('High Rider: invalid Spirit page configuration.', error);
      return null;
    }
  };

  const elementForRid = (root, rid) => rid ? root.querySelector(`[data-rid="${rid}"]`) : null;

  const setPlainText = (root, rid, value, selector = 'p') => {
    if (typeof value !== 'string') return;
    const target = elementForRid(root, rid);
    if (!target) return;
    const textElement = target.matches(selector) ? target : target.querySelector(selector) || target;
    textElement.textContent = value;
  };

  const setRichText = (root, rid, value) => {
    if (typeof value !== 'string') return;
    const target = elementForRid(root, rid);
    if (!target) return;
    const richText = target.matches('.alchemy-rte') ? target : target.querySelector('.alchemy-rte') || target;
    const wrapper = richText.querySelector(':scope > span') || richText;
    wrapper.innerHTML = value;
  };

  const setPictureSource = (root, rid, url) => {
    if (!url) return;
    const picture = elementForRid(root, rid);
    if (!picture) return;
    const isOfferArtwork = rid === MEDIA_RIDS.offer1 || rid === MEDIA_RIDS.offer2 || rid === MEDIA_RIDS.offer3;
    picture.querySelectorAll('source').forEach((source) => { source.srcset = url; });
    picture.querySelectorAll('img').forEach((image) => {
      if (isOfferArtwork) {
        image.loading = 'lazy';
        image.decoding = 'async';
      }
      image.src = url;
      image.removeAttribute('srcset');
    });
  };

  const combineOfferShippingAndGuarantee = (root, offers, label) => {
    if (!Array.isArray(offers)) return;

    const shippingLabel = String(label || '').trim().replace(/^\+\s*/, '');

    offers.forEach((offer) => {
      const rids = OFFER_RIDS[offer.bundle];
      const guarantee = elementForRid(root, rids?.guarantee);
      const guaranteeRow = guarantee?.parentElement;
      if (!guaranteeRow || guaranteeRow.dataset.hrOfferBenefitsLine === String(offer.bundle)) return;

      root.querySelector(`[data-hr-offer-free-shipping="${offer.bundle}"]`)?.remove();
      const guaranteeText = guarantee.querySelector('p') || guarantee;
      const guaranteeLabel = guaranteeText.textContent.trim().replace(/^\+\s*/, '');
      guaranteeText.textContent = String(offer.bundle) === '1'
        ? guaranteeLabel
        : [shippingLabel, guaranteeLabel].filter(Boolean).join(' · ');
      guaranteeRow.dataset.hrOfferBenefitsLine = String(offer.bundle);
      guaranteeRow.classList.add('hr-spirit-offer-benefits-line');
    });
  };

  const syncGallerySlides = (carousel, galleryImages, galleryAlt) => {
    if (!Array.isArray(galleryImages) || !galleryImages.length) return;

    const tracks = [...carousel.querySelectorAll('[data-replo-part="slide-track"]')];
    const mainTrack = tracks.find((track) => track.dataset.reploRootId?.includes('R9urir2')) || tracks[0];

    tracks.forEach((track, trackIndex) => {
      const seen = new Set();
      const slides = [...track.children]
        .filter((node) => node.matches('[data-replo-part="slide"]'))
        .filter((slide) => {
          const sourceIndex = slide.dataset.slideSourceIndex ?? slide.dataset.slideIndex;
          if (seen.has(sourceIndex)) return false;
          seen.add(sourceIndex);
          return true;
        });
      if (!slides.length) return;

      const template = slides[slides.length - 1];
      const isThumbnailTrack = track !== mainTrack;
      const normalizedSlides = galleryImages.map((media, index) => {
        const slide = slides[index] || template.cloneNode(true);
        const slideId = `hr-spirit-fp-gallery-${trackIndex}-${index}`;
        slide.id = slideId;
        slide.dataset.slideId = slideId;
        slide.dataset.slideIndex = String(index);
        slide.dataset.slideSourceIndex = String(index);
        slide.dataset.isActive = String(index === 0);
        slide.removeAttribute('data-is-cloned');
        slide.removeAttribute('data-is-target');
        slide.setAttribute('aria-label', `Slide ${index + 1}`);

        if (isThumbnailTrack) {
          slide.removeAttribute('aria-hidden');
          slide.setAttribute('aria-current', index === 0 ? 'true' : 'false');
          slide.tabIndex = 0;
        } else {
          slide.setAttribute('aria-hidden', String(index !== 0));
          slide.tabIndex = index === 0 ? 0 : -1;
        }

        if (media?.url) {
          const thumbnailUrl = media.thumbnailUrl || media.url;
          const displayUrl = isThumbnailTrack || index > 0 ? thumbnailUrl : media.url;
          const shouldHydrate = !isThumbnailTrack && index > 0 && displayUrl !== media.url;

          slide.querySelectorAll('source').forEach((source) => { source.srcset = displayUrl; });
          slide.querySelectorAll('img').forEach((image) => {
            image.src = displayUrl;
            image.removeAttribute('srcset');
            image.loading = !isThumbnailTrack && index === 0 ? 'eager' : 'lazy';
            image.decoding = 'async';
            image.setAttribute('fetchpriority', !isThumbnailTrack && index === 0 ? 'high' : 'low');
          });

          if (shouldHydrate) {
            slide.dataset.fullSrc = media.url;
            slide.dataset.fullHydrated = 'false';
          } else {
            delete slide.dataset.fullSrc;
            slide.dataset.fullHydrated = 'true';
          }
        }
        if (typeof galleryAlt === 'string') {
          slide.querySelectorAll('img').forEach((image) => { image.alt = galleryAlt; });
        }
        return slide;
      });

      track.replaceChildren(...normalizedSlides);
    });
  };

  const initializePurchaseContent = (root, config) => {
    const content = config.purchaseContent;
    if (!content) return;

    setPlainText(root, '1205495a-95da-494d-b50d-44d617706b50', content.dosage);
    setPlainText(root, 'fa3eaea7-1ade-4813-b421-a90d8f5702bc', content.brand);
    const brandTarget = elementForRid(root, 'fa3eaea7-1ade-4813-b421-a90d8f5702bc');
    const brandRow = brandTarget?.closest('[data-rid="90e48149-4efd-4dc1-8b7e-294e240d841d"]');
    const brandNoteText = String(content.brandNote || '').trim();
    const existingBrandNote = brandRow?.querySelector('[data-hr-spirit-brand-note]');

    if (brandRow && brandNoteText) {
      const brandNote = existingBrandNote || document.createElement('small');
      brandRow.dataset.hrSpiritTitleWithNote = 'true';
      brandNote.dataset.hrSpiritBrandNote = '';
      brandNote.textContent = brandNoteText;
      if (!existingBrandNote) brandRow.append(brandNote);
    } else {
      existingBrandNote?.remove();
      brandRow?.removeAttribute('data-hr-spirit-title-with-note');
    }
    setPlainText(root, 'd51657c2-8eef-4b75-84cd-85be27cadce1', content.productName);
    setPlainText(root, '59c513ce-7de0-448a-917b-9788caa2cbf6', content.warningTitle);
    setRichText(root, '90a152f7-48c3-4331-b410-7ffa0f9eac13', content.warningBody);

    const carousel = root.querySelector('[data-replo-carousel="true"]');
    if (carousel) {
      syncGallerySlides(carousel, content.galleryImages, content.galleryAlt);
    }

    Object.entries(content.mediaAssets || {}).forEach(([key, url]) => {
      setPictureSource(root, MEDIA_RIDS[key], url);
    });

    content.benefits?.forEach((benefit) => {
      setPlainText(root, BENEFIT_RIDS[benefit.target], benefit.text, 'strong');
    });

    content.offers?.forEach((offer) => {
      const rids = OFFER_RIDS[offer.bundle];
      if (!rids) return;
      Object.entries(rids).forEach(([field, rid]) => setPlainText(root, rid, offer[field]));
      setPlainText(root, rids.quantity, String(offer.bundle));
    });
    setPlainText(root, THREE_PLUS_QUANTITY_RID, config.threePlusLabel || '3+');
    combineOfferShippingAndGuarantee(root, content.offers, config.freeShippingLabel);

    content.details?.forEach((detail) => {
      const rids = DETAIL_RIDS[detail.target];
      if (!rids) return;
      setPlainText(root, rids.heading, detail.heading);
      setRichText(root, rids.body, detail.body);
      setRichText(root, rids.bodySecondary, detail.bodySecondary);
      setRichText(root, rids.bodyTertiary, detail.bodyTertiary);
    });
  };

  const uniqueOriginalSlides = (track) => {
    const slides = [...track.children].filter((node) => node.matches('[data-replo-part="slide"]'));
    const originals = slides.filter((node) => node.dataset.isCloned !== 'true');
    const candidates = originals.length ? originals : slides;
    const seen = new Set();

    return candidates.filter((slide) => {
      const sourceIndex = slide.dataset.slideSourceIndex || slide.dataset.slideIndex;
      if (seen.has(sourceIndex)) return false;
      seen.add(sourceIndex);
      return true;
    });
  };

  const hydrateMainSlide = (slide) => {
    const fullSrc = slide?.dataset.fullSrc;
    if (!fullSrc || slide.dataset.fullHydrated === 'true' || slide.dataset.fullHydrated === 'pending') return;

    slide.dataset.fullHydrated = 'pending';
    const preloader = new Image();
    preloader.decoding = 'async';
    preloader.fetchPriority = 'high';

    const applyFullSource = () => {
      slide.querySelectorAll('source').forEach((source) => { source.srcset = fullSrc; });
      slide.querySelectorAll('img').forEach((image) => {
        image.src = fullSrc;
        image.loading = 'eager';
        image.setAttribute('fetchpriority', 'high');
      });
      slide.dataset.fullHydrated = 'true';
      delete slide.dataset.fullSrc;
    };

    preloader.addEventListener('load', applyFullSource, { once: true });
    preloader.addEventListener('error', () => {
      slide.dataset.fullHydrated = 'false';
    }, { once: true });
    preloader.src = fullSrc;
    if (preloader.complete && preloader.naturalWidth) applyFullSource();
  };

  const initializeCarousel = (root) => {
    const carousel = root.querySelector('[data-replo-carousel="true"]');
    if (!carousel) return;

    const tracks = [...carousel.querySelectorAll('[data-replo-part="slide-track"]')];
    const mainTrack = tracks.find((track) => track.dataset.reploRootId?.includes('R9urir2')) || tracks[0];
    const thumbnailTrack = tracks.find((track) => track !== mainTrack);
    if (!mainTrack) return;

    const mainSlides = uniqueOriginalSlides(mainTrack);
    const thumbnailSlides = thumbnailTrack ? uniqueOriginalSlides(thumbnailTrack) : [];
    const thumbnailViewport = thumbnailTrack?.parentElement?.parentElement;
    const status = carousel.querySelector('[aria-live="polite"]');
    const previous = carousel.querySelector('[data-direction="previous"]');
    const next = carousel.querySelector('[data-direction="next"]');
    let activeIndex = 0;
    let touchStartX = null;

    thumbnailViewport?.classList.add('hr-spirit-thumbnail-scroll');

    const positionTrack = (track, slide, animate) => {
      if (!track || !slide) return;
      track.style.transitionDuration = animate ? '320ms' : '0ms';
      track.style.transitionProperty = 'transform';
      track.style.transform = `translate3d(${-slide.offsetLeft}px, 0, 0)`;
    };

    const setActive = (index, animate = true) => {
      if (!mainSlides.length) return;
      activeIndex = (index + mainSlides.length) % mainSlides.length;
      const activeSource = mainSlides[activeIndex].dataset.slideSourceIndex || String(activeIndex);
      hydrateMainSlide(mainSlides[activeIndex]);

      [...mainTrack.children].forEach((slide) => {
        if (!slide.matches('[data-replo-part="slide"]')) return;
        const isActive = slide.dataset.isCloned !== 'true' &&
          (slide.dataset.slideSourceIndex || slide.dataset.slideIndex) === activeSource;
        slide.dataset.isActive = String(isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
        slide.tabIndex = isActive ? 0 : -1;
      });

      positionTrack(mainTrack, mainSlides[activeIndex], animate);

      if (thumbnailTrack && thumbnailSlides.length) {
        [...thumbnailTrack.children].forEach((slide) => {
          if (!slide.matches('[data-replo-part="slide"]')) return;
          const isActive = slide.dataset.isCloned !== 'true' &&
            (slide.dataset.slideSourceIndex || slide.dataset.slideIndex) === activeSource;
          slide.dataset.isActive = String(isActive);
          slide.setAttribute('aria-current', isActive ? 'true' : 'false');
          slide.firstElementChild?.classList.toggle(THUMBNAIL_ACTIVE_FRAME_CLASS, isActive);
        });

        const activeThumbnail = thumbnailSlides[activeIndex];
        if (thumbnailViewport && activeThumbnail) {
          const maxOffset = Math.max(0, thumbnailTrack.scrollWidth - thumbnailViewport.clientWidth);
          const desiredOffset = activeThumbnail.offsetLeft -
            (thumbnailViewport.clientWidth - activeThumbnail.offsetWidth) / 2;
          const offset = Math.min(maxOffset, Math.max(0, desiredOffset));
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          thumbnailTrack.style.transitionDuration = '0ms';
          thumbnailTrack.style.transitionProperty = 'none';
          thumbnailTrack.style.transform = 'none';
          thumbnailViewport.scrollTo({
            left: offset,
            behavior: animate && !reducedMotion ? 'smooth' : 'auto'
          });
        }
      }

      if (status) status.textContent = `Slide ${activeIndex + 1} of ${mainSlides.length}`;
    };

    previous?.addEventListener('click', () => setActive(activeIndex - 1));
    next?.addEventListener('click', () => setActive(activeIndex + 1));

    thumbnailSlides.forEach((slide, index) => {
      slide.setAttribute('role', 'button');
      slide.tabIndex = 0;
      slide.addEventListener('click', () => setActive(index));
      slide.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        setActive(index);
      });
    });

    carousel.addEventListener('touchstart', (event) => {
      if (thumbnailViewport?.contains(event.target)) {
        touchStartX = null;
        return;
      }
      touchStartX = event.changedTouches[0]?.clientX ?? null;
    }, { passive: true });

    carousel.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const distance = (event.changedTouches[0]?.clientX ?? touchStartX) - touchStartX;
      touchStartX = null;
      if (Math.abs(distance) < 40) return;
      setActive(activeIndex + (distance < 0 ? 1 : -1));
    }, { passive: true });

    let resizeFrame;
    window.addEventListener('resize', () => {
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(() => setActive(activeIndex, false));
    });

    requestAnimationFrame(() => setActive(0, false));
  };

  const initializeCollapsibles = (root) => {
    root.querySelectorAll('[data-replo-collapsible]').forEach((collapsible) => {
      const trigger = collapsible.querySelector(':scope > [role="button"][aria-controls]');
      const content = trigger ? root.querySelector(`#${CSS.escape(trigger.getAttribute('aria-controls'))}`) : null;
      if (!trigger || !content) return;

      const toggle = () => {
        const willOpen = trigger.getAttribute('aria-expanded') !== 'true';
        trigger.setAttribute('aria-expanded', String(willOpen));
        collapsible.dataset.state = willOpen ? 'open' : 'closed';
        content.dataset.state = willOpen ? 'open' : 'closed';
        content.hidden = !willOpen;
      };

      trigger.addEventListener('click', toggle);
      trigger.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        toggle();
      });
    });
  };

  const initializeAnchorActions = (root) => {
    const offerButtonRids = [
      '2cabf364-5d16-4197-88ab-a4a6bdfd6196',
      '69a3fa1c-1675-4bc9-991f-a131ded48eae',
      '353045f0-2ee9-4749-bf13-14f100a5425f'
    ];

    offerButtonRids.forEach((rid) => {
      root.querySelectorAll(`[data-rid="${rid}"]`).forEach((button) => {
        button.dataset.hrAnchorAction = 'offer';
        button.addEventListener('click', (event) => {
          const offer = document.getElementById('Shop Now');
          if (!offer) return;

          event.preventDefault();
          offer.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    });

    root.querySelectorAll('[data-rid="eab966df-9119-4a31-b12b-c17739da8864"]').forEach((button) => {
      button.dataset.hrAnchorAction = 'top';
      button.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    });
  };

  const initializeReviewLinks = (container = document) => {
    const resolveReviewsTarget = () => {
      const appRoot = document.querySelector('[data-hr-spirit-owned] [data-copy-profile="app"]');
      const curatedReviews = appRoot?.querySelector('[data-hr-spirit-social-proof]');

      if (curatedReviews) {
        if (!curatedReviews.id) curatedReviews.id = 'hr-spirit-app-reviews';
        return curatedReviews;
      }

      return document.getElementById('judgeme_product_reviews');
    };
    const candidates = [];
    if (container.matches?.('[data-hr-spirit-reviews-link], .jdgm-preview-badge')) candidates.push(container);
    candidates.push(...container.querySelectorAll?.('[data-hr-spirit-reviews-link], .jdgm-preview-badge') || []);

    candidates.forEach((link) => {
      if (link.dataset.hrReviewsInitialized === 'true') return;
      link.dataset.hrReviewsInitialized = 'true';

      if (!link.hasAttribute('role')) link.setAttribute('role', 'link');
      if (!link.hasAttribute('tabindex')) link.tabIndex = 0;
      const initialReviewsTarget = resolveReviewsTarget();
      link.setAttribute('aria-controls', initialReviewsTarget?.id || 'judgeme_product_reviews');
      if (!link.hasAttribute('aria-label')) link.setAttribute('aria-label', 'Read customer reviews');

      const scrollToReviews = () => {
        const reviews = resolveReviewsTarget();
        if (!reviews) return;
        reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      link.addEventListener('click', scrollToReviews);
      link.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        scrollToReviews();
      });
    });
  };

  const syncIntroReviewCount = (source = document.querySelector(REVIEW_COUNT_SOURCE_SELECTOR)) => {
    const target = document.querySelector(REVIEW_COUNT_TARGET_SELECTOR);
    if (!source || !target) return false;

    const rawCount = source.getAttribute('data-number-of-reviews') || '';
    const reviewCount = Number.parseInt(rawCount.replace(/[^0-9]/g, ''), 10);
    if (!Number.isFinite(reviewCount) || reviewCount < 0) return false;

    const currentText = target.textContent.trim();
    const rating = target.dataset.hrReviewRating
      || currentText.match(/^([0-9]+(?:\.[0-9]+)?)/)?.[1]
      || '4.8';
    const formattedCount = reviewCount.toLocaleString('en-US');
    const riderLabel = reviewCount === 1 ? 'Rider' : 'Riders';

    target.dataset.hrReviewRating = rating;
    target.dataset.hrJudgeReviewCount = String(reviewCount);
    target.textContent = `${rating} / 5 from ${formattedCount} ${riderLabel}`;

    const reviewLink = target.closest('[data-hr-spirit-reviews-link]');
    if (reviewLink) {
      reviewLink.setAttribute(
        'aria-label',
        `Read customer reviews: ${rating} out of 5 stars from ${formattedCount} ${riderLabel.toLowerCase()}`
      );
    }

    return true;
  };

  const observeReviewCountSource = (source) => {
    if (!source || source === reviewCountSource) return;

    reviewCountObserver?.disconnect();
    reviewCountSource = source;
    reviewCountObserver = new MutationObserver(() => syncIntroReviewCount(source));
    reviewCountObserver.observe(source, {
      attributes: true,
      attributeFilter: ['data-number-of-reviews'],
      childList: true,
      characterData: true,
      subtree: true
    });
  };

  const initializeReviewCountSync = () => {
    const source = document.querySelector(REVIEW_COUNT_SOURCE_SELECTOR);
    if (source) {
      reviewCountDiscoveryObserver?.disconnect();
      reviewCountDiscoveryObserver = null;
      observeReviewCountSource(source);
      syncIntroReviewCount(source);
      return;
    }

    if (reviewCountDiscoveryObserver || !document.body) return;
    reviewCountDiscoveryObserver = new MutationObserver(() => {
      const discoveredSource = document.querySelector(REVIEW_COUNT_SOURCE_SELECTOR);
      if (!discoveredSource) return;

      reviewCountDiscoveryObserver.disconnect();
      reviewCountDiscoveryObserver = null;
      observeReviewCountSource(discoveredSource);
      syncIntroReviewCount(discoveredSource);
    });
    reviewCountDiscoveryObserver.observe(document.body, { childList: true, subtree: true });
  };

  const initializeProductForm = (root, config) => {
    const optionList = root.querySelector('[data-replo-option-select="true"]');
    const optionNodes = optionList ? [...optionList.querySelectorAll(':scope > [role="option"]')] : [];
    const mixMatchPanel = root.querySelector('[data-hr-spirit-mix-match]');
    const packPreview = mixMatchPanel?.querySelector('[data-hr-pack-preview]');
    const packBottles = packPreview?.querySelector('[data-hr-pack-bottles]');
    const packSummary = packPreview?.querySelector('[data-hr-pack-summary]');
    const mixMessage = mixMatchPanel?.querySelector('[data-hr-mix-message]');
    const bottleAssets = {
      B: { src: packPreview?.dataset.hrBerryBottleSrc || '', width: 237, height: 600 },
      S: { src: packPreview?.dataset.hrStrawberryBottleSrc || '', width: 237, height: 600 },
      P: { src: packPreview?.dataset.hrPeachBottleSrc || '', width: 237, height: 600 }
    };
    const form = root.querySelector('form[action="/cart/add"]');
    const variantInput = form?.querySelector('[name="id"]');
    const quantityInput = form?.querySelector('[name="quantity"]');
    const buttons = [...root.querySelectorAll('[data-replo-add-product-variant-to-cart]')];
    let selectedIndex = Math.max(0, Math.min(optionNodes.length - 1, Number(config.defaultBundle || 1) - 1));
    let isLoading = false;
    let cartError = '';
    let lastPackPreviewSignature = '';
    const threePlusMaximum = Math.max(
      THREE_PLUS_MINIMUM,
      Math.min(DEFAULT_THREE_PLUS_MAXIMUM, Number(config.threePlusMaximum) || DEFAULT_THREE_PLUS_MAXIMUM)
    );

    if (!optionList || !optionNodes.length || !mixMatchPanel || !form || !variantInput || !buttons.length || !config.variants?.length) return;

    const selectedMixes = Object.fromEntries(
      Object.entries(DEFAULT_SPIRIT_MIXES).map(([packSize, counts]) => [packSize, { ...counts }])
    );
    const hasOwn = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
    const flavorOrder = Object.fromEntries(SPIRIT_FLAVORS.map((flavor, index) => [flavor.key, index]));
    const unavailableFlavorKeys = new Set(
      String(mixMatchPanel.dataset.hrUnavailableFlavors || '')
        .split(',')
        .map((key) => key.trim().toUpperCase())
        .filter((key) => hasOwn(flavorOrder, key))
    );
    const flavorIsUnavailable = (flavorKey) => unavailableFlavorKeys.has(flavorKey);
    Object.values(selectedMixes).forEach((counts) => {
      let displaced = 0;
      SPIRIT_FLAVORS.forEach((flavor) => {
        if (!flavorIsUnavailable(flavor.key)) return;
        displaced += Number(counts[flavor.key] || 0);
        counts[flavor.key] = 0;
      });
      if (!displaced) return;
      const fallback = SPIRIT_FLAVORS.find((flavor) => (
        flavor.key === 'P' && !flavorIsUnavailable(flavor.key)
      )) || SPIRIT_FLAVORS.find((flavor) => (
        !flavorIsUnavailable(flavor.key) && Number(counts[flavor.key] || 0) > 0
      )) || SPIRIT_FLAVORS.find((flavor) => !flavorIsUnavailable(flavor.key));
      if (fallback) counts[fallback.key] = Number(counts[fallback.key] || 0) + displaced;
    });
    const canonicalMix = (mix) => [...String(mix || '').toUpperCase()]
      .filter((key) => hasOwn(flavorOrder, key))
      .sort((left, right) => flavorOrder[left] - flavorOrder[right])
      .join('');
    const variantKeyFromSku = (variant) => {
      const sku = String(variant.sku || '').trim().toUpperCase();
      const legacyMatch = sku.match(/-(1|2|3)-([BSP]+)$/);
      const currentMatch = sku.match(/-((?:BER|STR|PEA)(?:-(?:BER|STR|PEA)){0,2})-([123])$/);
      if (!legacyMatch && !currentMatch) return null;
      const packSize = Number(legacyMatch?.[1] || currentMatch[2]);
      const mix = canonicalMix(legacyMatch
        ? legacyMatch[2]
        : currentMatch[1].split('-').map((token) => SKU_FLAVOR_KEYS[token]).join(''));
      return mix.length === packSize ? `${packSize}:${mix}` : null;
    };
    const addOnFlavorFromSku = (variant) => {
      const sku = String(variant.sku || '').trim().toUpperCase();
      const legacyMatch = sku.match(/-ADD-([BSP])$/);
      if (legacyMatch && hasOwn(flavorOrder, legacyMatch[1])) return legacyMatch[1];
      const currentMatch = sku.match(/-(BER|STR|PEA)-ADD$/);
      return currentMatch ? SKU_FLAVOR_KEYS[currentMatch[1]] : null;
    };
    const variantsByMix = new Map();
    const addOnVariantsByFlavor = new Map();

    config.variants.forEach((variant) => {
      const key = variantKeyFromSku(variant);
      if (key) {
        if (variantsByMix.has(key)) console.warn(`High Rider: duplicate Spirit flavor mix ${key}.`);
        else variantsByMix.set(key, variant);
      }

      const addOnFlavor = addOnFlavorFromSku(variant);
      if (!addOnFlavor) return;
      if (addOnVariantsByFlavor.has(addOnFlavor)) {
        console.warn(`High Rider: duplicate additional-bottle variant for ${addOnFlavor}.`);
        return;
      }
      addOnVariantsByFlavor.set(addOnFlavor, variant);
    });

    const missingVariantKeys = Object.entries(EXPECTED_SPIRIT_MIXES).flatMap(([packSize, mixes]) => (
      mixes.filter((mix) => !variantsByMix.has(`${packSize}:${mix}`)).map((mix) => `${packSize}:${mix}`)
    ));
    const variantMapComplete = missingVariantKeys.length === 0;
    if (!variantMapComplete) {
      root.dataset.hrVariantMapError = missingVariantKeys.join(',');
      console.error(`High Rider: missing Spirit flavor variants: ${missingVariantKeys.join(', ')}.`);
    } else {
      delete root.dataset.hrVariantMapError;
    }

    const missingAddOnFlavorKeys = SPIRIT_FLAVORS
      .map((flavor) => flavor.key)
      .filter((flavorKey) => !addOnVariantsByFlavor.has(flavorKey));
    const invalidAddOnPriceKeys = SPIRIT_FLAVORS
      .map((flavor) => flavor.key)
      .filter((flavorKey) => {
        const variant = addOnVariantsByFlavor.get(flavorKey);
        return variant && Number(variant.price) !== ADDITIONAL_BOTTLE_PRICE_CENTS;
      });
    const addOnVariantMapComplete = missingAddOnFlavorKeys.length === 0;
    const addOnPricesValid = invalidAddOnPriceKeys.length === 0;
    if (!addOnVariantMapComplete || !addOnPricesValid) {
      root.dataset.hrAddOnVariantError = [
        ...missingAddOnFlavorKeys.map((key) => `missing:${key}`),
        ...invalidAddOnPriceKeys.map((key) => `price:${key}`)
      ].join(',');
      console.error(`High Rider: additional-bottle variants are invalid: ${root.dataset.hrAddOnVariantError}.`);
    } else {
      delete root.dataset.hrAddOnVariantError;
    }

    const packSizeForIndex = (index) => index + 1;
    const isThreePlusIndex = (index) => index === THREE_PLUS_OPTION_INDEX;
    const selectedCounts = () => selectedMixes[packSizeForIndex(selectedIndex)];
    const selectedTotal = (counts = selectedCounts()) => SPIRIT_FLAVORS.reduce(
      (total, flavor) => total + Number(counts?.[flavor.key] || 0),
      0
    );
    const replacementFlavorFor = (counts, targetFlavorKey) => SPIRIT_FLAVORS
      .filter((flavor) => (
        !flavorIsUnavailable(flavor.key) &&
        flavor.key !== targetFlavorKey &&
        Number(counts?.[flavor.key] || 0) > 0
      ))
      .sort((left, right) => {
        const quantityDifference = Number(counts[right.key] || 0) - Number(counts[left.key] || 0);
        return quantityDifference || flavorOrder[right.key] - flavorOrder[left.key];
      })[0] || null;
    const mixForCounts = (counts) => SPIRIT_FLAVORS.map(
      (flavor) => flavor.key.repeat(Number(counts?.[flavor.key] || 0))
    ).join('');
    const selectionLimits = (index = selectedIndex) => {
      const minimum = packSizeForIndex(index);
      return {
        minimum,
        maximum: isThreePlusIndex(index) ? threePlusMaximum : minimum
      };
    };
    const baseCountsForSelection = (counts, index = selectedIndex) => {
      if (!isThreePlusIndex(index)) return { ...counts };

      const baseCounts = Object.fromEntries(SPIRIT_FLAVORS.map((flavor) => [flavor.key, 0]));
      let remaining = THREE_PLUS_MINIMUM;

      // Preserve one of every selected flavor in the three-bottle base whenever possible.
      SPIRIT_FLAVORS.forEach((flavor) => {
        const quantity = Math.max(0, Number(counts?.[flavor.key] || 0));
        if (!quantity || !remaining) return;
        baseCounts[flavor.key] = 1;
        remaining -= 1;
      });

      while (remaining > 0) {
        const nextFlavor = SPIRIT_FLAVORS
          .filter((flavor) => Number(counts?.[flavor.key] || 0) > baseCounts[flavor.key])
          .sort((left, right) => {
            const leftRemainder = Number(counts?.[left.key] || 0) - baseCounts[left.key];
            const rightRemainder = Number(counts?.[right.key] || 0) - baseCounts[right.key];
            return rightRemainder - leftRemainder || flavorOrder[left.key] - flavorOrder[right.key];
          })[0];
        if (!nextFlavor) return null;
        baseCounts[nextFlavor.key] += 1;
        remaining -= 1;
      }

      return remaining === 0 ? baseCounts : null;
    };
    const cartPlanForSelection = (counts = selectedCounts(), index = selectedIndex) => {
      if (SPIRIT_FLAVORS.some((flavor) => (
        flavorIsUnavailable(flavor.key) && Number(counts?.[flavor.key] || 0) > 0
      ))) return null;
      const { minimum, maximum } = selectionLimits(index);
      const total = selectedTotal(counts);
      if (!counts || total < minimum || total > maximum) return null;
      if (!isThreePlusIndex(index) && total !== minimum) return null;

      const baseCounts = baseCountsForSelection(counts, index);
      if (!baseCounts) return null;
      const basePackSize = isThreePlusIndex(index) ? THREE_PLUS_MINIMUM : minimum;
      const baseVariant = variantsByMix.get(`${basePackSize}:${mixForCounts(baseCounts)}`) || null;
      const items = baseVariant ? [{ variant: baseVariant, quantity: 1, role: 'base' }] : [];
      const missingAddOns = [];
      const invalidAddOnPrices = [];

      if (isThreePlusIndex(index)) {
        SPIRIT_FLAVORS.forEach((flavor) => {
          const extraQuantity = Number(counts[flavor.key] || 0) - Number(baseCounts[flavor.key] || 0);
          if (extraQuantity <= 0) return;
          const addOnVariant = addOnVariantsByFlavor.get(flavor.key);
          if (!addOnVariant) {
            missingAddOns.push(flavor.key);
            return;
          }
          if (Number(addOnVariant.price) !== ADDITIONAL_BOTTLE_PRICE_CENTS) {
            invalidAddOnPrices.push(flavor.key);
            return;
          }
          items.push({ variant: addOnVariant, quantity: extraQuantity, role: 'add-on', flavor });
        });
      }

      const complete = Boolean(baseVariant) && missingAddOns.length === 0 && invalidAddOnPrices.length === 0;
      const unavailableItems = complete ? items.filter((item) => !item.variant.available) : [];
      return {
        baseVariant,
        items,
        total,
        complete,
        available: complete && unavailableItems.length === 0,
        missingAddOns,
        invalidAddOnPrices,
        unavailableItems
      };
    };
    const nextCountsForIncrement = (counts, flavorKey, index = selectedIndex) => {
      if (flavorIsUnavailable(flavorKey)) return null;
      const nextCounts = { ...counts };
      const { maximum } = selectionLimits(index);
      const total = selectedTotal(counts);

      if (isThreePlusIndex(index)) {
        if (total >= maximum) return null;
        nextCounts[flavorKey] += 1;
        return nextCounts;
      }

      if (total < maximum) {
        nextCounts[flavorKey] += 1;
        return nextCounts;
      }

      const replacementFlavor = replacementFlavorFor(counts, flavorKey);
      if (!replacementFlavor) return null;
      nextCounts[replacementFlavor.key] -= 1;
      nextCounts[flavorKey] += 1;
      return nextCounts;
    };
    const priceLabelToCents = (value) => {
      const numeric = Number(String(value || '').replace(/[^0-9.]/g, ''));
      return Number.isFinite(numeric) ? Math.round(numeric * 100) : 0;
    };
    const formatUsd = (cents) => {
      const amount = (Number(cents) / 100).toFixed(2);
      return `$${amount.endsWith('.00') ? amount.slice(0, -3) : amount}`;
    };
    const formatTruncatedUsd = (cents) => `$${Math.floor(Number(cents) / 100).toLocaleString('en-US')}`;
    const threePlusOffer = config.purchaseContent?.offers?.find((offer) => String(offer.bundle) === '3');
    const threePlusBasePriceCents = CHECKOUT_BUNDLE_TOTALS_CENTS[THREE_PLUS_MINIMUM];
    const threePlusBaseComparePriceCents = priceLabelToCents(threePlusOffer?.comparePrice) || 36000;
    const threePlusComparePricePerBottleCents = Math.round(
      threePlusBaseComparePriceCents / THREE_PLUS_MINIMUM
    );
    const potencyLabel = config.copyProfile === 'app' ? 'hemp-derived THC' : 'THC';
    const threePlusPriceForTotal = (total) => (
      threePlusBasePriceCents + (total - THREE_PLUS_MINIMUM) * ADDITIONAL_BOTTLE_PRICE_CENTS
    );
    const updateThreePlusOfferPricing = (total) => {
      const priceCents = threePlusPriceForTotal(total);
      const comparePriceCents = threePlusComparePricePerBottleCents * total;
      const dosageMg = THC_PER_BOTTLE_MG * total;
      const centsPerMg = priceCents / dosageMg;
      const roundedSavingsCents = Math.round(
        Math.max(0, comparePriceCents - priceCents) / 1000
      ) * 1000;
      const rids = OFFER_RIDS['3'];

      setPlainText(
        root,
        rids.meta,
        `${dosageMg.toLocaleString('en-US')}MG ${potencyLabel} • ${centsPerMg.toFixed(1)}¢ / MG`
      );
      setPlainText(root, rids.price, formatTruncatedUsd(priceCents));
      setPlainText(root, rids.comparePrice, formatUsd(comparePriceCents));
      setPlainText(root, rids.savings, `Save ${formatUsd(roundedSavingsCents)}`);
    };

    optionList.setAttribute('role', 'radiogroup');
    optionList.setAttribute('aria-label', 'Choose a bottle offer');

    const updateButtonText = (label) => {
      buttons.forEach((button) => {
        button.querySelectorAll('p').forEach((text) => { text.textContent = label; });
      });
    };
    const clearCartError = () => {
      cartError = '';
      delete root.dataset.hrCartError;
      buttons.forEach((button) => button.removeAttribute('title'));
    };
    const naturalList = (items) => {
      if (items.length < 2) return items[0] || '';
      if (items.length === 2) return `${items[0]} and ${items[1]}`;
      return `${items.slice(0, -1).join(', ')}, and ${items[items.length - 1]}`;
    };
    const renderPackPreview = (packSize, counts, isThreePlus) => {
      if (!packPreview || !packBottles || !packSummary || !bottleAssets.S.src) return;

      const selectedBottleTotal = SPIRIT_FLAVORS.reduce(
        (total, flavor) => total + Number(counts?.[flavor.key] || 0),
        0
      );

      const previewSize = isThreePlus
        ? Math.max(THREE_PLUS_MINIMUM, Math.min(threePlusMaximum, selectedBottleTotal))
        : packSize;
      const groups = SPIRIT_FLAVORS.flatMap((flavor) => {
        const quantity = Number(counts?.[flavor.key] || 0);
        return quantity > 0 ? [{ flavor, quantity }] : [];
      });
      const remaining = Math.max(0, previewSize - selectedBottleTotal);
      if (remaining) groups.push({ flavor: null, quantity: remaining });
      const previewSignature = `${previewSize}:${groups
        .map(({ flavor, quantity }) => `${flavor?.key || '_'}${quantity}`)
        .join('|')}`;

      if (previewSignature !== lastPackPreviewSignature) {
        const fragment = document.createDocumentFragment();

        groups.forEach(({ flavor, quantity }) => {
          const slot = document.createElement('div');
          const visual = document.createElement('div');
          const label = document.createElement('span');

          slot.className = 'hr-spirit-pack-preview__bottle';
          slot.dataset.flavor = flavor?.key || 'empty';
          slot.dataset.quantity = String(quantity);
          visual.className = 'hr-spirit-pack-preview__visual';
          visual.style.setProperty('--hr-stack-marker-offset', `${((quantity - 1) / 2) * 22 - 3}px`);
          visual.style.setProperty('--hr-stack-marker-offset-mobile', `${((quantity - 1) / 2) * 18 - 3}px`);
          label.className = 'hr-spirit-pack-preview__bottle-name';

          for (let index = 0; index < quantity; index += 1) {
            const bottle = document.createElement('img');
            const selectedBottleAsset = flavor ? bottleAssets[flavor.key] : bottleAssets.S;
            const hasSelectedBottleAsset = Boolean(selectedBottleAsset?.src);
            const bottleAsset = hasSelectedBottleAsset ? selectedBottleAsset : bottleAssets.S;
            const centeredIndex = index - ((quantity - 1) / 2);

            bottle.className = 'hr-spirit-pack-preview__image';
            bottle.src = bottleAsset.src;
            bottle.alt = '';
            bottle.width = bottleAsset.width;
            bottle.height = bottleAsset.height;
            bottle.decoding = 'async';
            bottle.draggable = false;
            bottle.style.setProperty('--hr-stack-offset', `${centeredIndex * 22}px`);
            bottle.style.setProperty('--hr-stack-offset-mobile', `${centeredIndex * 18}px`);
            bottle.style.zIndex = String(index + 1);
            bottle.classList.add(
              !flavor
                ? 'hr-spirit-pack-preview__image--empty'
                : hasSelectedBottleAsset
                  ? 'hr-spirit-pack-preview__image--real'
                  : 'hr-spirit-pack-preview__image--silhouette'
            );
            visual.appendChild(bottle);
          }

          if (flavor) {
            const flavorLabel = document.createElement('span');
            flavorLabel.textContent = flavor.name;
            label.appendChild(flavorLabel);

            if (quantity > 1) {
              const countLabel = document.createElement('span');
              countLabel.className = 'hr-spirit-pack-preview__bottle-count';
              countLabel.textContent = `×${quantity}`;
              label.appendChild(countLabel);
            }

            const sourceMarker = mixMatchPanel.querySelector(
              `[data-hr-flavor-row="${flavor.key}"] .hr-spirit-mix-match__swatch`
            );
            if (sourceMarker) {
              const markerWrap = document.createElement('span');
              const marker = sourceMarker.cloneNode(true);
              markerWrap.className = 'hr-spirit-pack-preview__marker';
              marker.classList.add('hr-spirit-pack-preview__marker-image');
              marker.setAttribute('aria-hidden', 'true');
              markerWrap.appendChild(marker);
              visual.appendChild(markerWrap);
            }
          } else {
            const emptyLabel = document.createElement('span');
            emptyLabel.textContent = 'Choose flavor';
            label.appendChild(emptyLabel);

            if (quantity > 1) {
              const countLabel = document.createElement('span');
              countLabel.className = 'hr-spirit-pack-preview__bottle-count';
              countLabel.textContent = `×${quantity}`;
              label.appendChild(countLabel);
            }
          }

          slot.append(visual, label);
          fragment.appendChild(slot);
        });

        packBottles.replaceChildren(fragment);
        lastPackPreviewSignature = previewSignature;
      }
      packPreview.dataset.packSize = String(previewSize);
      packPreview.dataset.flavorGroups = String(groups.length);

      const selectedDescriptions = SPIRIT_FLAVORS.flatMap((flavor) => {
        const quantity = Number(counts?.[flavor.key] || 0);
        if (!quantity) return [];
        return [quantity > 1 ? `${flavor.name} ×${quantity}` : flavor.name];
      });
      const chosenDescription = naturalList(selectedDescriptions) || 'no flavors selected';
      const summaryText = `Your pack: ${chosenDescription}.`;
      if (packSummary.textContent !== summaryText) packSummary.textContent = summaryText;
    };

    const renderSelection = () => {
      const packSize = packSizeForIndex(selectedIndex);
      const isThreePlus = isThreePlusIndex(selectedIndex);
      const { minimum, maximum } = selectionLimits();
      const counts = selectedCounts();
      const total = selectedTotal(counts);
      const remaining = Math.max(0, minimum - total);
      const cartPlan = cartPlanForSelection(counts);
      const baseVariant = cartPlan?.baseVariant || null;
      const selectedOption = optionNodes[selectedIndex];

      variantInput.value = baseVariant?.id || '';
      if (quantityInput) quantityInput.value = '1';

      optionNodes.forEach((option, optionIndex) => {
        const isSelected = optionIndex === selectedIndex;
        const optionPackSize = packSizeForIndex(optionIndex);
        const optionIsThreePlus = isThreePlusIndex(optionIndex);
        const hasPackVariants = EXPECTED_SPIRIT_MIXES[optionPackSize].every(
          (mix) => variantsByMix.has(`${optionPackSize}:${mix}`)
        );
        const hasRequiredVariants = hasPackVariants && (
          !optionIsThreePlus || (addOnVariantMapComplete && addOnPricesValid)
        );

        option.dataset.hrOfferOption = optionIsThreePlus ? '3+' : String(optionPackSize);
        option.setAttribute('role', 'radio');
        option.removeAttribute('aria-selected');
        option.setAttribute('aria-checked', String(isSelected));
        option.setAttribute('aria-disabled', String(isLoading || !hasRequiredVariants));
        option.setAttribute('aria-expanded', String(isSelected));
        if (optionIsThreePlus && isSelected && mixMessage?.id) option.setAttribute('aria-describedby', mixMessage.id);
        else option.removeAttribute('aria-describedby');
        if (isSelected) option.setAttribute('aria-controls', mixMatchPanel.id);
        else option.removeAttribute('aria-controls');
        option.tabIndex = isSelected ? 0 : -1;
        const selectedClass = SELECTED_OPTION_CLASSES[option.dataset.rid];
        if (selectedClass) option.classList.toggle(selectedClass, isSelected);
        option.classList.toggle('hr-spirit-offer--expanded', isSelected);
      });

      if (selectedOption.nextElementSibling !== mixMatchPanel) selectedOption.after(mixMatchPanel);
      mixMatchPanel.hidden = false;
      mixMatchPanel.dataset.packSize = isThreePlus ? '3+' : String(packSize);
      mixMatchPanel.dataset.resolvedSku = baseVariant?.sku || '';
      mixMatchPanel.dataset.resolvedVariantId = baseVariant?.id ? String(baseVariant.id) : '';
      mixMatchPanel.dataset.resolvedAddOnSkus = cartPlan?.items
        ?.filter((item) => item.role === 'add-on')
        .map((item) => `${item.variant.sku}:${item.quantity}`)
        .join(',') || '';
      mixMatchPanel.dataset.selectedMix = mixForCounts(counts);
      root.dataset.hrSelectedPack = isThreePlus ? '3+' : String(packSize);

      const status = mixMatchPanel.querySelector('[data-hr-mix-status]');
      const statusText = isThreePlus
        ? `${total} selected · max ${maximum}`
        : `${total} of ${packSize} selected`;
      if (status && status.textContent !== statusText) status.textContent = statusText;
      renderPackPreview(packSize, counts, isThreePlus);
      if (isThreePlus) updateThreePlusOfferPricing(total);

      SPIRIT_FLAVORS.forEach((flavor) => {
        const quantity = Number(counts[flavor.key] || 0);
        const flavorUnavailable = flavorIsUnavailable(flavor.key);
        const row = mixMatchPanel.querySelector(`[data-hr-flavor-row="${flavor.key}"]`);
        const counter = mixMatchPanel.querySelector(`[data-hr-flavor-counter="${flavor.key}"]`);
        const output = mixMatchPanel.querySelector(`[data-hr-flavor-quantity="${flavor.key}"]`);
        const unavailableLabel = row?.querySelector('[data-hr-flavor-unavailable]');
        const decrement = mixMatchPanel.querySelector(`[data-hr-flavor-action="decrement"][data-hr-flavor="${flavor.key}"]`);
        const increment = mixMatchPanel.querySelector(`[data-hr-flavor-action="increment"][data-hr-flavor="${flavor.key}"]`);
        const replacementFlavor = replacementFlavorFor(counts, flavor.key);
        const incrementCounts = nextCountsForIncrement(counts, flavor.key);
        const incrementPlan = isThreePlus && incrementCounts
          ? cartPlanForSelection(incrementCounts)
          : null;
        const incrementUnavailable = isThreePlus && incrementCounts && (
          !incrementPlan?.complete || !incrementPlan.available
        );

        if (row) {
          row.dataset.selected = String(quantity > 0);
          row.dataset.unavailable = String(flavorUnavailable);
        }
        if (unavailableLabel) unavailableLabel.hidden = !flavorUnavailable;
        if (counter) counter.setAttribute(
          'aria-label',
          `${flavor.name} quantity: ${quantity}${flavorUnavailable ? ', sold out' : ''}`
        );
        if (output) {
          output.textContent = String(quantity);
        }
        if (decrement) {
          const atThreePlusMinimum = isThreePlus && total <= minimum;
          decrement.disabled = flavorUnavailable || quantity === 0 || isLoading || atThreePlusMinimum;
          decrement.setAttribute('aria-disabled', String(decrement.disabled));
          decrement.setAttribute(
            'aria-label',
            flavorUnavailable
              ? `${flavor.name} is sold out`
              : (atThreePlusMinimum ? `Minimum ${minimum} bottles selected` : `Remove one ${flavor.name} bottle`)
          );
          decrement.title = flavorUnavailable
            ? 'Sold out'
            : (atThreePlusMinimum ? `Minimum ${minimum} bottles` : '');
        }
        if (increment) {
          increment.disabled = flavorUnavailable || isLoading || !incrementCounts || incrementUnavailable;
          increment.setAttribute('aria-disabled', String(increment.disabled));
          let incrementLabel = `Add one ${flavor.name} bottle`;
          if (flavorUnavailable) incrementLabel = `${flavor.name} is sold out`;
          else if (isThreePlus && total >= maximum) incrementLabel = `Maximum ${maximum} bottles selected`;
          else if (incrementUnavailable) incrementLabel = `Additional ${flavor.name} bottle unavailable`;
          else if (!isThreePlus && total >= packSize && replacementFlavor) {
            incrementLabel = `Replace one ${replacementFlavor.name} bottle with ${flavor.name}`;
          }
          increment.setAttribute('aria-label', incrementLabel);
          increment.title = flavorUnavailable
            ? 'Sold out'
            : (isThreePlus && total >= maximum ? `Maximum ${maximum} bottles` : '');
        }
      });

      let selectionMessage = '';
      if (cartError) selectionMessage = cartError;
      else if (!variantMapComplete) selectionMessage = 'This offer is temporarily unavailable.';
      else if (isThreePlus && (!addOnVariantMapComplete || !addOnPricesValid)) {
        selectionMessage = 'Additional bottles are temporarily unavailable.';
      } else if (remaining) {
        selectionMessage = `Choose ${remaining} more ${remaining === 1 ? 'bottle' : 'bottles'} to complete your pack.`;
      } else if (!baseVariant) selectionMessage = 'This flavor combination is unavailable.';
      else if (!cartPlan?.complete) selectionMessage = 'This flavor combination is unavailable.';
      else if (!cartPlan.available) selectionMessage = 'This flavor combination is currently sold out.';
      else if (isThreePlus && total < maximum) {
        selectionMessage = config.threePlusMessage || 'Add more bottles for just $89.99 ea.';
      } else if (isThreePlus) selectionMessage = `Maximum of ${maximum} bottles selected.`;

      if (mixMessage) {
        mixMessage.textContent = selectionMessage;
        mixMessage.hidden = !selectionMessage;
        mixMessage.dataset.type = cartError ? 'error' : 'status';
        mixMessage.toggleAttribute('role', Boolean(cartError));
        if (cartError) mixMessage.setAttribute('role', 'alert');
      }

      const canAdd = variantMapComplete &&
        (!isThreePlus || (addOnVariantMapComplete && addOnPricesValid)) &&
        !isLoading &&
        !remaining &&
        Boolean(cartPlan?.complete && cartPlan.available);
      buttons.forEach((button) => {
        button.setAttribute('aria-disabled', String(!canAdd));
        button.toggleAttribute('disabled', !canAdd);
        if (!cartError) button.removeAttribute('title');
      });

      let buttonLabel;
      if (remaining) buttonLabel = `Choose ${remaining} More`;
      else if (!cartPlan?.available) buttonLabel = config.soldOutLabel;
      else if (isThreePlus) {
        buttonLabel = `Add ${total} Bottles — ${formatTruncatedUsd(threePlusPriceForTotal(total))}`;
      } else buttonLabel = config.addToCartLabel;
      updateButtonText(buttonLabel);

      return cartPlan;
    };

    optionNodes.forEach((option, index) => {
      option.addEventListener('click', () => {
        if (isLoading || option.getAttribute('aria-disabled') === 'true') return;
        clearCartError();
        selectedIndex = index;
        renderSelection();
      });
      option.addEventListener('keydown', (event) => {
        if (isLoading) return;
        const movementKeys = ['ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown', 'Home', 'End'];
        if (event.key !== 'Enter' && event.key !== ' ' && !movementKeys.includes(event.key)) return;
        event.preventDefault();
        const enabledIndexes = optionNodes.map((candidate, candidateIndex) => (
          candidate.getAttribute('aria-disabled') === 'true' ? -1 : candidateIndex
        )).filter((candidateIndex) => candidateIndex >= 0);
        if (!enabledIndexes.length) return;

        if (event.key === 'Enter' || event.key === ' ') {
          if (option.getAttribute('aria-disabled') === 'true') return;
          selectedIndex = index;
        } else if (event.key === 'Home') selectedIndex = enabledIndexes[0];
        else if (event.key === 'End') selectedIndex = enabledIndexes[enabledIndexes.length - 1];
        else {
          const direction = event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 1;
          let candidateIndex = index;
          do {
            candidateIndex = (candidateIndex + direction + optionNodes.length) % optionNodes.length;
          } while (optionNodes[candidateIndex].getAttribute('aria-disabled') === 'true' && candidateIndex !== index);
          if (optionNodes[candidateIndex].getAttribute('aria-disabled') === 'true') return;
          selectedIndex = candidateIndex;
        }
        clearCartError();
        renderSelection();
        optionNodes[selectedIndex].focus();
      });
    });

    mixMatchPanel.addEventListener('click', (event) => {
      if (isLoading) return;
      const control = event.target instanceof Element
        ? event.target.closest('[data-hr-flavor-action]')
        : null;
      if (!control || control.disabled) return;
      event.preventDefault();
      event.stopPropagation();

      const flavorKey = control.dataset.hrFlavor;
      const action = control.dataset.hrFlavorAction;
      const counts = selectedCounts();
      if (!hasOwn(counts, flavorKey)) return;
      if (flavorIsUnavailable(flavorKey)) return;

      if (
        action === 'decrement' &&
        counts[flavorKey] > 0 &&
        (!isThreePlusIndex(selectedIndex) || selectedTotal(counts) > THREE_PLUS_MINIMUM)
      ) counts[flavorKey] -= 1;
      if (action === 'increment') {
        const nextCounts = nextCountsForIncrement(counts, flavorKey);
        if (nextCounts) SPIRIT_FLAVORS.forEach((flavor) => { counts[flavor.key] = nextCounts[flavor.key]; });
      }
      clearCartError();
      renderSelection();
    });

    const setLoading = (loading) => {
      isLoading = loading;
      buttons.forEach((button) => {
        let indicator = button.querySelector('.hr-spirit-loading-indicator');
        if (!indicator) {
          indicator = document.createElement('span');
          indicator.className = 'hr-spirit-loading-indicator';
          indicator.setAttribute('aria-hidden', 'true');
          indicator.innerHTML = '<span>LOADING</span><span class="hr-spirit-loading-spinner"></span>';
          button.appendChild(indicator);
        }

        const renderedLabel = [...button.querySelectorAll('p')].find((label) => {
          const labelContainer = label.closest('[data-rid]') || label.parentElement;
          return window.getComputedStyle(labelContainer).display !== 'none';
        }) || button.querySelector('p');

        if (renderedLabel) {
          const labelStyles = window.getComputedStyle(renderedLabel);
          indicator.style.fontFamily = labelStyles.fontFamily;
          indicator.style.fontSize = labelStyles.fontSize;
          indicator.style.fontStyle = labelStyles.fontStyle;
          indicator.style.fontWeight = labelStyles.fontWeight;
          indicator.style.lineHeight = labelStyles.lineHeight;
          indicator.style.letterSpacing = labelStyles.letterSpacing;
          indicator.style.textTransform = labelStyles.textTransform;
          indicator.style.color = labelStyles.color;
        }

        button.dataset.hrLoading = String(loading);
        button.setAttribute('aria-busy', String(loading));
        if (loading) {
          button.setAttribute('aria-disabled', 'true');
          button.disabled = true;
        }
      });
    };

    const shopifyRoot = window.Shopify?.routes?.root || '/';
    const cartRoute = (path) => `${shopifyRoot}${String(path).replace(/^\/+/, '')}`;
    const cartDrawerSectionIds = ['cart-drawer', 'cart-icon-bubble'];
    const cartDrawerSectionPayload = () => ({
      sections: cartDrawerSectionIds,
      sections_url: `${window.location.pathname}${window.location.search}`
    });
    const parseCartResponse = async (response, fallbackMessage) => {
      const responseText = await response.text();
      let state;

      try {
        state = JSON.parse(responseText);
      } catch (_error) {
        throw new Error(`Shopify returned an unexpected ${response.status} response.`);
      }

      if (!response.ok || state?.status) {
        throw new Error(state?.description || state?.message || fallbackMessage);
      }
      return state;
    };
    const postCartJson = async (path, body, fallbackMessage) => {
      const response = await fetch(cartRoute(path), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
      });
      return parseCartResponse(response, fallbackMessage);
    };
    const clearCart = async () => {
      await postCartJson('cart/clear.js', {}, 'Unable to prepare your cart. Please try again.');
    };
    const removeCartDiscount = async () => {
      await postCartJson('cart/update.js', { discount: '' }, 'Unable to prepare this offer. Please try again.');
    };
    const resetCart = async () => {
      await clearCart();
      await removeCartDiscount();
    };
    const getCart = async () => {
      const response = await fetch(cartRoute('cart.js'), {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      return parseCartResponse(response, 'Unable to verify your cart. Please try again.');
    };

    const applyDiscount = async (code) => {
      if (!config.applyBundleDiscounts) return getCart();
      if (!code) throw new Error('This offer is temporarily unavailable. Please try again later.');
      return postCartJson(
        'cart/update.js',
        { discount: code, ...cartDrawerSectionPayload() },
        'Unable to apply this offer. Please try again.'
      );
    };
    const expectedCartTotal = (offerIndex, plan) => {
      const bundle = packSizeForIndex(offerIndex);
      if (!config.applyBundleDiscounts) {
        return plan.items.reduce(
          (total, item) => total + Number(item.variant.price || 0) * Number(item.quantity || 0),
          0
        );
      }

      const baseTotal = CHECKOUT_BUNDLE_TOTALS_CENTS[bundle];
      if (!baseTotal) throw new Error('This offer price is temporarily unavailable.');
      const additionalBottles = isThreePlusIndex(offerIndex)
        ? Math.max(0, plan.total - THREE_PLUS_MINIMUM)
        : 0;
      return baseTotal + additionalBottles * ADDITIONAL_BOTTLE_PRICE_CENTS;
    };
    const validateCart = (cart, plan, expectedTotal) => {
      const expectedQuantities = new Map();
      plan.items.forEach((item) => {
        const variantId = Number(item.variant.id);
        expectedQuantities.set(
          variantId,
          (expectedQuantities.get(variantId) || 0) + Number(item.quantity || 0)
        );
      });

      const actualQuantities = new Map();
      cart.items?.forEach((item) => {
        const variantId = Number(item.variant_id || item.id);
        actualQuantities.set(variantId, (actualQuantities.get(variantId) || 0) + Number(item.quantity || 0));
      });

      const quantitiesMatch = expectedQuantities.size === actualQuantities.size &&
        [...expectedQuantities].every(([variantId, quantity]) => actualQuantities.get(variantId) === quantity);
      if (!quantitiesMatch) throw new Error('Your bottle selection could not be verified.');

      const addOnVariantIds = new Set(
        plan.items.filter((item) => item.role === 'add-on').map((item) => Number(item.variant.id))
      );
      if (addOnVariantIds.size) {
        const baseLine = cart.items?.find((item) => Number(item.variant_id || item.id) === Number(plan.baseVariant.id));
        const nestedLines = cart.items?.filter((item) => addOnVariantIds.has(Number(item.variant_id || item.id))) || [];
        const nestedRelationshipsMatch = Boolean(baseLine?.key) &&
          nestedLines.length === addOnVariantIds.size &&
          nestedLines.every((item) => item.parent_relationship?.parent_key === baseLine.key);
        if (!nestedRelationshipsMatch) throw new Error('Your additional bottles could not be linked to this offer.');
      }

      if (Number(cart.total_price) !== Number(expectedTotal)) {
        throw new Error(CART_PRICE_VERIFICATION_ERROR);
      }
    };

    const applyAndConfirmDiscount = async (code, plan, expectedTotal) => {
      if (!config.applyBundleDiscounts) {
        const cart = await applyDiscount(code);
        validateCart(cart, plan, expectedTotal);
        return cart;
      }

      let priceError = null;
      for (const delayMs of CART_CONFIRMATION_DELAYS_MS) {
        await applyDiscount(code);
        await new Promise((resolve) => window.setTimeout(resolve, delayMs));
        const cart = await getCart();
        try {
          validateCart(cart, plan, expectedTotal);
          return cart;
        } catch (error) {
          if (error?.message !== CART_PRICE_VERIFICATION_ERROR) throw error;
          priceError = error;
        }
      }
      throw priceError || new Error(CART_PRICE_VERIFICATION_ERROR);
    };

    const isVisibleInViewport = (element) => {
      if (!element) return false;
      const styles = window.getComputedStyle(element);
      const bounds = element.getBoundingClientRect();
      return styles.display !== 'none' &&
        styles.visibility !== 'hidden' &&
        styles.opacity !== '0' &&
        bounds.width > 0 &&
        bounds.height > 0 &&
        bounds.right > 0 &&
        bounds.bottom > 0 &&
        bounds.left < window.innerWidth &&
        bounds.top < window.innerHeight;
    };
    const eliteCartIsOpen = () => {
      const backdrop = document.getElementById('EliteCartBackdrop');
      const panel = document.querySelector(
        '#EliteCartContainer.ec-cart-container, #EliteCartContainer .ec-cart-container, [role="dialog"].ec-cart-container, [role="dialog"] .ec-cart-container'
      );
      return isVisibleInViewport(backdrop) || isVisibleInViewport(panel);
    };
    const openEliteCart = async (timeoutMs) => {
      let refreshRequested = false;
      const deadline = Date.now() + timeoutMs;

      while (Date.now() < deadline) {
        if (eliteCartIsOpen()) return true;

        const open = window.EliteCart?.openDrawerWithDataRefresh;
        if (!refreshRequested && typeof open === 'function') {
          refreshRequested = true;
          try {
            await open.call(window.EliteCart);
            return true;
          } catch (error) {
            console.warn('High Rider: EliteCart could not be opened.', error);
            return false;
          }
        }

        await new Promise((resolve) => window.setTimeout(resolve, 100));
      }

      return eliteCartIsOpen();
    };
    const requestCartDrawerSections = async () => {
      const sectionUrl = new URL(window.location.href);
      sectionUrl.hash = '';
      sectionUrl.searchParams.set('sections', cartDrawerSectionIds.join(','));
      const response = await fetch(sectionUrl.toString(), {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      return parseCartResponse(response, 'Unable to load the cart drawer.');
    };
    const openNativeCartDrawer = async (cart) => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (typeof cartDrawer?.renderContents !== 'function') return false;

      let sections = cart?.sections;
      if (!sections || cartDrawerSectionIds.some((sectionId) => !sections[sectionId])) {
        sections = await requestCartDrawerSections();
      }

      cartDrawer.classList.remove('is-empty');
      cartDrawer.renderContents({
        ...cart,
        id: cart?.items?.[0]?.product_id || config.productId,
        sections
      });
      return true;
    };
    const openCartDrawer = async (cart) => {
      if (await openEliteCart(500)) return true;

      const nativeDeadline = Date.now() + 2000;
      while (Date.now() < nativeDeadline) {
        if (eliteCartIsOpen()) return true;
        const cartDrawer = document.querySelector('cart-drawer');
        if (typeof cartDrawer?.renderContents === 'function') {
          if (eliteCartIsOpen()) return true;
          return openNativeCartDrawer(cart);
        }
        await new Promise((resolve) => window.setTimeout(resolve, 100));
      }

      if (eliteCartIsOpen()) return true;
      return openNativeCartDrawer(cart);
    };

    const addToCart = async (trigger) => {
      const offerIndex = selectedIndex;
      const counts = { ...selectedCounts() };
      const cartPlan = cartPlanForSelection(counts, offerIndex);
      if (
        isLoading ||
        !cartPlan?.complete ||
        !cartPlan.available ||
        trigger.getAttribute('aria-disabled') === 'true'
      ) return;
      const discountCode = config.discountCodes?.[offerIndex];
      const cartItems = cartPlan.items.map((item) => {
        const cartItem = {
          id: Number(item.variant.id),
          quantity: Number(item.quantity)
        };
        if (item.role === 'add-on') cartItem.parent_id = Number(cartPlan.baseVariant.id);
        return cartItem;
      });
      let cartPrepared = false;

      clearCartError();
      setLoading(true);
      renderSelection();

      try {
        const expectedTotal = expectedCartTotal(offerIndex, cartPlan);
        await resetCart();
        cartPrepared = true;
        await postCartJson('cart/add.js', { items: cartItems }, 'Unable to add this bottle selection.');
        const cart = await applyAndConfirmDiscount(discountCode, cartPlan, expectedTotal);

        try {
          document.dispatchEvent(new CustomEvent('high-rider:cart-added', {
            detail: {
              productId: config.productId,
              variantId: cartPlan.baseVariant.id,
              variantIds: cartItems.map((item) => item.id),
              items: cartItems,
              cartData: cart
            }
          }));

          const cartDrawerOpened = await openCartDrawer(cart);
          if (!cartDrawerOpened) window.location.assign(window.routes?.cart_url || cartRoute('cart'));
        } catch (presentationError) {
          console.error('High Rider: cart drawer failed.', presentationError);
          window.location.assign(window.routes?.cart_url || cartRoute('cart'));
        }
      } catch (error) {
        let cleanupSucceeded = false;
        let cleanupFailed = false;
        if (cartPrepared) {
          try {
            await resetCart();
            cleanupSucceeded = true;
          } catch (cleanupError) {
            cleanupFailed = true;
            console.error('High Rider: cart cleanup failed.', cleanupError);
          }
        }
        console.error('High Rider: add to cart failed.', error);
        if (cleanupFailed) {
          cartError = 'We could not verify this offer. Please remove any Spirit items from your cart before checkout.';
        } else {
          cartError = error?.message || 'Unable to add this item.';
          if (cleanupSucceeded) cartError = `${cartError} Your cart was reset; please try again.`;
        }
        root.dataset.hrCartError = cartError;
        buttons.forEach((button) => {
          button.setAttribute('title', root.dataset.hrCartError);
        });
      } finally {
        setLoading(false);
        renderSelection();
      }
    };

    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        addToCart(button);
      });
    });

    renderSelection();
  };

  const hydrateDeferredVideo = (video) => {
    if (video.dataset.hrSpiritMediaLoaded === 'true') return;

    const sources = Array.from(video.querySelectorAll('source[data-src]'));
    if (!sources.length) return;

    sources.forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.dataset.hrSpiritMediaLoaded = 'true';
    deferredVideoObserver?.unobserve(video);
    video.load();
  };

  const getDeferredVideoObserver = () => {
    if (!('IntersectionObserver' in window)) return null;
    if (deferredVideoObserver) return deferredVideoObserver;

    deferredVideoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) hydrateDeferredVideo(entry.target);
      });
    }, { rootMargin: '600px 0px' });

    return deferredVideoObserver;
  };

  const initializeDeferredVideo = (video) => {
    if (video.dataset.hrSpiritDeferredInitialized === 'true') return;
    video.dataset.hrSpiritDeferredInitialized = 'true';

    const hydrateOnIntent = () => hydrateDeferredVideo(video);
    video.addEventListener('pointerdown', hydrateOnIntent, { once: true, passive: true });
    video.addEventListener('click', hydrateOnIntent, { once: true });
    video.addEventListener('keydown', hydrateOnIntent, { once: true });

    const observer = getDeferredVideoObserver();
    if (observer) observer.observe(video);
    else hydrateDeferredVideo(video);
  };

  const toCssUrl = (url) => `url(${JSON.stringify(url)})`;

  const hydrateDeferredBackground = (section) => {
    if (section.dataset.hrSpiritBackgroundLoaded === 'true') return;

    const desktopUrl = section.dataset.hrSpiritGoodHighDesktopBackground;
    const mobileUrl = section.dataset.hrSpiritGoodHighMobileBackground || desktopUrl;
    if (!desktopUrl) return;

    section.style.setProperty('--hr-spirit-good-high-background-desktop', toCssUrl(desktopUrl));
    section.style.setProperty('--hr-spirit-good-high-background-mobile', toCssUrl(mobileUrl));
    section.dataset.hrSpiritBackgroundLoaded = 'true';
    deferredBackgroundObserver?.unobserve(section);
  };

  const getDeferredBackgroundObserver = () => {
    if (!('IntersectionObserver' in window)) return null;
    if (deferredBackgroundObserver) return deferredBackgroundObserver;

    deferredBackgroundObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) hydrateDeferredBackground(entry.target);
      });
    }, { rootMargin: '1200px 0px' });

    return deferredBackgroundObserver;
  };

  const initializeDeferredBackground = (section) => {
    if (section.dataset.hrSpiritDeferredInitialized === 'true') return;
    section.dataset.hrSpiritDeferredInitialized = 'true';

    const observer = getDeferredBackgroundObserver();
    if (observer) observer.observe(section);
    else hydrateDeferredBackground(section);
  };

  const initializeDeferredMedia = (container) => {
    if (container.matches?.(DEFERRED_VIDEO_SELECTOR)) initializeDeferredVideo(container);
    container.querySelectorAll?.(DEFERRED_VIDEO_SELECTOR).forEach(initializeDeferredVideo);
    if (container.matches?.(DEFERRED_BACKGROUND_SELECTOR)) initializeDeferredBackground(container);
    container.querySelectorAll?.(DEFERRED_BACKGROUND_SELECTOR).forEach(initializeDeferredBackground);
  };

  const unobserveDeferredMedia = (container) => {
    if (container.matches?.(DEFERRED_VIDEO_SELECTOR)) deferredVideoObserver?.unobserve(container);
    container.querySelectorAll?.(DEFERRED_VIDEO_SELECTOR).forEach((video) => {
      deferredVideoObserver?.unobserve(video);
    });
    if (container.matches?.(DEFERRED_BACKGROUND_SELECTOR)) deferredBackgroundObserver?.unobserve(container);
    container.querySelectorAll?.(DEFERRED_BACKGROUND_SELECTOR).forEach((section) => {
      deferredBackgroundObserver?.unobserve(section);
    });
  };

  const initialize = (root) => {
    if (root.dataset.hrInitialized === 'true') return;
    const config = parseConfig(root);
    if (!config) return;
    root.dataset.hrInitialized = 'true';

    initializePurchaseContent(root, config);
    initializeCarousel(root);
    initializeCollapsibles(root);
    initializeAnchorActions(root);
    initializeProductForm(root, config);
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        root.dataset.hrSpiritReady = 'true';
      });
    });
  };

  const initializeTail = (root) => {
    if (root.dataset.hrTailInitialized === 'true') return;
    root.dataset.hrTailInitialized = 'true';
    initializeCollapsibles(root);
    initializeAnchorActions(root);
  };

  const initializeAll = (container = document) => {
    try {
      initializeDeferredMedia(container);
    } catch (error) {
      console.error('High Rider: deferred media initialization failed.', error);
    }
    if (container.matches?.(ROOT_SELECTOR)) initialize(container);
    container.querySelectorAll?.(ROOT_SELECTOR).forEach(initialize);
    if (container.matches?.(TAIL_SELECTOR)) initializeTail(container);
    container.querySelectorAll?.(TAIL_SELECTOR).forEach(initializeTail);
    initializeReviewLinks(container);
    initializeReviewCountSync();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => unobserveDeferredMedia(event.target));
})();
